import { createSlice, PayloadAction } from '@reduxjs/toolkit';

const TabKey = ['apps', 'manage', 'channels', 'business', 'settings', 'webforms'] as const;
type TabKeyType = typeof TabKey[number];
export interface AdminState {
  currentTab: TabKeyType;
}

const initialState: AdminState = {
  currentTab: 'manage',
};

const admin = createSlice({
  name: 'admin',
  initialState,
  reducers: {
    setCurrentTab: (state, action: PayloadAction<AdminState['currentTab']>) => {
      state.currentTab = action.payload;
    },
  },
});

export const { setCurrentTab } = admin.actions;
export default admin.reducer;
